<template>
  <v-card class="requests-panel" rounded="xl" elevation="0">
    <div class="requests-panel__header">
      <div class="d-flex align-center">
        <v-icon color="#b5421e" class="mr-2">mdi-account-clock-outline</v-icon>
        <div>
          <div class="requests-panel__title">
            {{
              $tc("classRequests.waiting", requests.length, {
                count: requests.length,
              })
            }}
          </div>
          <div class="requests-panel__subtitle">
            {{ $t("classRequests.subtitle") }}
          </div>
        </div>
      </div>
    </div>

    <v-row dense class="mt-2">
      <v-col v-for="student in requests" :key="student.id" cols="12" md="6">
        <class-member-card
          :student="student"
          :theme="theme"
          :normalized-times="normalizedTimes"
          :class-days="classDays"
          :experimental="experimental"
          :trial-date="trialDate"
          :trial-scheduled-at="trialScheduledAt"
          :trial-happened="trialHappened"
          show-actions
          @reload="$emit('reload')"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import ClassMemberCard from "@/components/classes/ClassMemberCard.vue";

export default {
  name: "ClassRequestsPanel",

  components: {
    ClassMemberCard,
  },

  props: {
    requests: {
      type: Array,
      default: () => [],
    },
    theme: {
      type: Object,
      required: true,
    },
    normalizedTimes: {
      type: Array,
      default: () => [],
    },
    classDays: {
      type: Array,
      default: () => [],
    },
    experimental: {
      type: Boolean,
      default: false,
    },
    // Data (YYYY-MM-DD) que o aluno escolheu ao pedir a experimental.
    trialDate: {
      type: String,
      default: null,
    },
    // Card 86aje36nz: data do evento da experimental, quando ja agendada.
    trialScheduledAt: {
      type: String,
      default: null,
    },
    // A experimental ja aconteceu (decidido pela API no relogio da escola).
    trialHappened: {
      type: Boolean,
      default: null,
    },
  },
};
</script>

<style scoped>
.requests-panel {
  padding: 18px 20px 8px;
  border: 1px solid rgba(255, 93, 42, 0.28);
  border-radius: 20px;
  background: linear-gradient(
    180deg,
    rgba(255, 93, 42, 0.06) 0%,
    var(--dk-surface, #ffffff) 60%
  );
}

.requests-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.requests-panel__title {
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--dk-ember-deep, #b5421e);
}

.requests-panel__subtitle {
  font-size: 0.88rem;
  color: var(--dk-muted, #6b6472);
  margin-top: 2px;
}
</style>
